<template>
  <div class="app-container">
    <el-form v-show="showSearch" ref="queryForm" :model="queryParams" size="small" :inline="true" label-width="78px">
      <dt-form-item
        :label="searchParamFormKey.label"
        :inputType="searchParamFormKey.type"
        v-model="queryParams.formKey"
        :propKey="searchParamFormKey.propKey"
        :options="searchParamFormKey.options"
        :componentAttr="searchParamFormKey.attrs"
        :valueRepeat="searchParamFormKey.valueRepeat"
        @clear="getList()"
      >
      </dt-form-item>

      <dt-form-item
        label="工单状态"
        inputType="select"
        v-model="queryParams.status"
        :options="statusArr"
        :componentAttr="{
          clearable: true,
          valueKey: 'label',
          placeholder: '工单状态'
        }"
        @clear="getList()"
      >
      </dt-form-item>
      <select-tree
        ref="selectTree"
        :defaultKeys="defaultKeys"
        title="所属组织"
        :options="shopOptions"
        :defaultProps="defaultProps"
      ></select-tree>
      <dt-form-item
        label="创建时间"
        inputType="date-picker"
        v-model="datePicker"
        :componentAttr="{
          type: 'daterange',
          'range-separator': '至',
          'start-placeholder': '开始日期',
          'end-placeholder': '结束日期',
          'value-format': 'yyyy-MM-dd',
          clearable: false,
          'unlink-panels': true
        }"
        @clear="getList()"
      >
      </dt-form-item>

      <el-form-item>
        <el-button type="primary" icon="el-icon-search" size="mini" @click="handleQuery"> 搜索 </el-button>
        <el-button icon="el-icon-refresh" size="mini" @click="resetQuery"> 重置 </el-button>
      </el-form-item>
    </el-form>

    <el-row :gutter="10" class="mb8" type="flex" justify="space-between">
      <el-col :span="1.5">
        <el-radio-group v-model="belongUser" @change="selectedDelongUser" v-removeAriaHidden>
          <el-radio-button label="">全部工单</el-radio-button>
          <el-radio-button :label="1">我的待处理</el-radio-button>
          <el-radio-button :label="2">我的已处理</el-radio-button>
        </el-radio-group>
      </el-col>
      <el-col :span="1.5">
        <el-button
          v-permission="['workOrderList_batchCloseWorkOrder']"
          type="primary"
          plain
          size="small"
          @click="handleCloseOrder"
        >
          批量关闭
        </el-button>
        <el-button
          v-permission="['workOrderList_exportWorkOrders']"
          type="primary"
          plain
          size="small"
          @click="handleExport"
        >
          导出
        </el-button>
      </el-col>
    </el-row>

    <el-table
      style="margin-top: 10px"
      v-loading="loading"
      :data="workOrderList"
      @selection-change="handleSelectionChange"
    >
      <el-table-column type="selection" width="45" align="center" :selectable="handleDisable" />
      <el-table-column label="编码" align="center" prop="code" />
      <el-table-column label="工单名称" align="center" prop="name" />
      <el-table-column label="触发问卷" align="center" prop="formName" width="100px" />
      <el-table-column label="状态" align="center" prop="id" width="80px">
        <template slot-scope="{ row }">
          <el-tag :type="row.status ? 'info' : ''">
            {{ row.status ? '已关闭' : '处理中' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="品牌" align="center" prop="brandName"></el-table-column>
      <el-table-column label="大区" align="center" prop="parentPartitionName" />
      <el-table-column label="分区" align="center" prop="locatedPartitionName" />
      <el-table-column label="门店" align="center" prop="shopName" />
      <el-table-column label="组织编码" align="center" prop="shopCode" />
      <el-table-column label="处理人" align="center" prop="transactorName" show-overflow-tooltip>
        <template slot-scope="{ row }">
          {{ row.transactorName.join('，') }}
        </template>
      </el-table-column>
      <el-table-column label="创建时间" align="center" prop="createTime"></el-table-column>
      <el-table-column label="关闭时间" align="center" prop="closeTime"></el-table-column>
      <el-table-column
        v-permission="['workOrderList_detail']"
        label="操作"
        align="center"
        class-name="small-padding fixed-width"
      >
        <template slot-scope="{ row }">
          <el-button
            v-permission="['workOrderList_detail']"
            size="mini"
            type="text"
            icon="el-icon-edit"
            @click="handleUpdate(row)"
          >
            查看
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <pagination
      v-show="total > 0"
      :total="total"
      :page.sync="queryParams.current"
      :limit.sync="queryParams.size"
      @pagination="getList"
    />

    <order-operator
      ref="operatorForm"
      title="关闭原因"
      placeholder="请输入关闭原因"
      @handleConfirm="handleCloseOrderConfirm"
    ></order-operator>
  </div>
</template>

<script>
import { getWorkOrderList, exportWorkOrders, handleBatchCloseWorkOrder } from '@/api/workOrder/list'
import Pagination from '@/components/Pagination'
import DtFormItem from '@/components/DtFormItem'
import OrderOperator from './components/OrderOperator'
import Treeselect from '@riophae/vue-treeselect' // 使用文档：https://vue-treeselect.js.org/
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import { getUserValidShops } from '@/api/project/data'
import { searchParamFormKey, statusArr } from '../input'

let searchParams = null
export default {
  name: 'User',
  components: { Pagination, Treeselect, DtFormItem, OrderOperator },
  data() {
    return {
      defaultProps: {
        children: 'children',
        label: 'name'
      },
      shopOptions: [],
      multipleSelection: [],
      datePicker: [],
      searchParamFormKey,
      statusArr,
      // 按钮loading
      buttonLoading: false,
      // 遮罩层
      loading: true,
      // 选中数组
      ids: [],
      // 显示搜索条件
      showSearch: true,
      // 总条数
      total: 0,
      // 用户表格数据
      workOrderList: [],
      belongUser: '',
      // 查询参数
      queryParams: {
        current: 1,
        size: 20,
        formKey: '',
        status: '',
        shopCodes: [],
        belongUser: '',
        beginDateTime: '',
        endDateTime: ''
      },
      defaultKeys: []
    }
  },
  beforeRouteEnter(to, from, next) {
    //  清空搜索项
    if (from.path !== '/workOrder/detail') {
      searchParams = null
    }
    next()
  },
  beforeRouteLeave(to, from, next) {
    searchParams = {
      queryParams: this.queryParams,
      datePicker: this.datePicker,
      belongUser: this.belongUser
    }
    next()
  },
  created() {
    // 搜索缓存
    if (searchParams) {
      const { queryParams, datePicker, belongUser } = searchParams
      this.queryParams = queryParams
      this.belongUser = belongUser
      this.defaultKeys = this.queryParams.shopCodes
      this.queryParams.beginDateTime && (this.datePicker = datePicker)
    }
    this.getList()
    this.getAllShopList()
  },
  methods: {
    // 查询门店组织
    async getAllShopList() {
      const { data } = await getUserValidShops()
      this.shopOptions = data
    },
    handleDisable(row) {
      if (row.status == 1) {
        return false
      } else {
        return true
      }
    },
    async getList() {
      try {
        this.loading = true
        const { data } = await getWorkOrderList(this.queryParams)
        this.workOrderList = data.records
        this.total = data.total
      } finally {
        this.loading = false
      }
    },
    // 取消按钮
    cancel() {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset() {
      this.shopCode = []
      this.resetForm('form')
    },
    /** 搜索按钮操作 */
    handleQuery() {
      const _shopIds = this.$refs.selectTree?.selectItem || []
      this.queryParams.shopCodes = _shopIds.map((item) => item.code)
      const { datePicker } = this
      if (datePicker.length > 0) {
        this.queryParams.beginDateTime = datePicker[0] + ' 00:00:00'
        this.queryParams.endDateTime = datePicker[1] + ' 23:59:59'
      }
      this.queryParams.current = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery() {
      const { queryParams } = this
      const queryDefault = {
        formKey: '',
        status: '',
        shopCodes: [],
        belongUser: '',
        beginDateTime: '',
        endDateTime: ''
      }
      this.belongUser = ''
      this.datePicker = []
      this.queryParams = Object.assign({}, { ...queryParams, ...queryDefault })
      this.$refs.selectTree?.clearAll()
      this.handleQuery()
    },
    // 我的待/已处理筛选
    selectedDelongUser(val) {
      this.queryParams.belongUser = !!val
      if (val) this.queryParams.status = val - 1
      else this.queryParams.status = null
      this.handleQuery()
    },
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    // 批量关闭工单
    handleCloseOrder() {
      console.log('operatorForm', this.$refs.operatorForm)
      if (this.multipleSelection.length == 0) this.$message.warning('请勾选未关闭工单')
      else this.$refs.operatorForm.operatorDialogOpen = true
    },
    handleCloseOrderConfirm(closeResult) {
      const ids = this.multipleSelection.map((item) => item.id)
      handleBatchCloseWorkOrder({ ids, closeResult }).then((res) => {
        this.$message.success('批量关闭成功')
        this.$refs.operatorForm.operatorDialogOpen = false
        this.getList()
      })
    },
    handleExport() {
      const params = this.queryParams
      if (!params.beginDateTime) {
        this.$message.warning('请选择创建时间')
        return
      }
      exportWorkOrders({ ...params, size: '', current: '' })
        .then((response) => {
          const filename = response.headers['content-disposition']?.split('filename=')[1].split('.xlsx')[0]
          this.download(response.data, decodeURI(filename))
        })
        .catch(() => {})
    },
    handleUpdate(row) {
      this.$router.push({
        path: `/workOrder/detail`,
        query: { orderid: row.id }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
// .app-container {
//   overflow-y: auto;
// }
.is-error {
  margin-bottom: 32px;
}
</style>
